// extracted by mini-css-extract-plugin
export var activityContainer = "_o7-0";
export var typingIndicatorContainer = "_o7-1";
export var typingIndicatorDot = "_o7-2";
export var wave = "_o7-3";